import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "ui/icons";
import { IconButton } from "ui/button";
import { Flex, type FlexProps } from "@chakra-ui/react";

export function SliderNavigationButtons({
  previousButtonId,
  nextButtonId,
  ...props
}: { previousButtonId: string; nextButtonId: string } & FlexProps) {
  return (
    <Flex gap="smaller" {...props}>
      <IconButton id={previousButtonId} aria-label="Previous slide" variant="secondary" icon={ChevronLeftIcon} />
      <IconButton id={nextButtonId} aria-label="Next slide" variant="secondary" icon={ChevronRightIcon} />
    </Flex>
  );
}
